module.exports = __webpack_public_path__ + "static/media/thankyouGirl.0ddd0068.gif";